import { render, staticRenderFns } from "./GroupBuyRecords.vue?vue&type=template&id=1b3821a8"
import script from "./GroupBuyRecords.vue?vue&type=script&lang=js"
export * from "./GroupBuyRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports